import type { ComponentType, Context } from 'react';

/**
 * Provide model through context in command model driven components
 *
 * Consider using with `memo` to avoid rerendering the top level component on each usage.
 * Hardcoded to 'model' prop to allow reasonable typing & simple usage.
 *
 * @example
 *
 * const ZooView = withModelProvider(ZooContext, memo((
 * ));
 */
export const withModelProvider =
  <TModel,>(context: Context<TModel>) =>
  <Props,>(
    Component: ComponentType<Props>,
  ): ComponentType<Props & { model: TModel }> =>
  ({ model, ...props }) => (
    <context.Provider value={model}>
      <Component {...(props as any)} />
    </context.Provider>
  );
